var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5216 13.9107C27.5216 8.24178 24.1299 3.42325 19.0424 1.1557C13.9549 -1.11185 8.01952 0.0219203 4.0626 3.99014C0.105658 7.95834 -1.02489 13.9106 0.953582 19.0126C2.93205 24.1146 8.01952 27.5159 13.6723 27.5159H27.5216V13.9107ZM31.4785 13.9107C31.4785 8.24178 34.8701 3.42325 39.9576 1.1557C45.0451 -1.11185 50.9805 0.0219203 54.9374 3.99014C58.8943 7.95834 60.0249 13.9106 58.0464 19.0126C56.068 24.1146 50.9805 27.5159 45.3277 27.5159H31.4785V13.9107ZM31.4785 45.0894C31.4785 50.7582 34.8701 55.5768 39.9576 57.8443C45.0451 60.1119 50.9805 58.9781 54.9374 55.0099C58.8943 51.0417 60.0249 45.0894 58.0464 39.9874C56.068 34.8854 50.9805 31.4841 45.3277 31.4841H31.4785V45.0894ZM13.6723 55.0099C19.0424 55.0099 23.5646 50.7582 23.5646 45.0894V35.1688H13.6723C8.30216 35.1688 3.77996 39.4205 3.77996 45.0894C3.77996 50.7582 8.30216 55.0099 13.6723 55.0099ZM27.5216 45.0894C27.5216 50.7582 24.1299 55.5768 19.0424 57.8443C13.9549 60.1119 8.01952 58.9781 4.0626 55.0099C0.105658 51.0417 -1.02489 45.0894 0.953582 39.9874C2.93205 34.8854 8.01952 31.4841 13.6723 31.4841H27.5216V45.0894Z",
    fill: "#034737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClover);
export default __webpack_public_path__ + "static/media/Clover.13fff6c4ed98fa3c66bb0727a50b7f0a.svg";
export { ForwardRef as ReactComponent };